import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D370 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">
        You're viewing D370 - IT Leadership Foundations
      </h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 2.37 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            Honestly, a pointless course in my opinion. Also, super easy—don’t
            waste too much time on the course material.
            <br />
            <br /> Task 1: You take a strengths test and then expand on it. It’s
            more like an English course. <br />
            Task 2: You read the implementation document and write about it.
            Task 2 was actually easier than Task 1. <br />
            <br />
            <a href="https://www.reddit.com/r/WGU/comments/1c4lncu/d370_it_leadership_foundations/" target="_blank" rel="noreferrer">
              This Reddit post{" "}
            </a>
            mentions a template, but I couldn’t find one and didn’t need it
            either. I just made my own simple Word document with bullet points
            for answers.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default D370;
